import { API_URLS } from '@/config';
import type { TokenClaimResponse } from '@/types/token';
import type { TokenCampaignResponse } from '@/types/campaign';

export const tokenService = {
  async requestClaim(payload: {
    iban: string;
    fullName: string;
    token: string;
    campaignId: string;
  }): Promise<TokenClaimResponse> {
    const data = {
      specversion: '1.0',
      type: 'com.token.redemption.claim',
      data: {
        receiverIban: payload.iban,
        receiverName: payload.fullName,
        token: payload.token,
        campaignId: payload.campaignId,
      },
    };

    const response = await fetch(`${API_URLS.token}/events`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: { 'Content-Type': 'application/json' },
    });

    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }

    const json = await response.json();

    return json as TokenClaimResponse;
  },

  async getCampaign(payload: {
    campaignId: string;
  }): Promise<TokenCampaignResponse | undefined> {
    const data = {
      specversion: '1.0',
      type: 'com.token.campaign.get',
      data: {
        campaignId: payload.campaignId,
      },
    };

    const response = await fetch(`${API_URLS.token}/events`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: { 'Content-Type': 'application/json' },
    });

    if (!response.ok) {
      if (response.status === 404) {
        return undefined;
      }

      throw new Error(`Response status: ${response.status}`);
    }

    const json = await response.json();

    return json as TokenCampaignResponse;
  },
};
